module.exports = __webpack_public_path__ + "img/GreekTechPodromosS_ua.fde4e5eb.webp";